import { format, subDays } from 'date-fns';
import { RANGE_DATE } from './filtersConstants';

export const RANGE_DATE_PRESET = {
  LAST_7_DAYS: 'last7Days',
  LAST_30_DAYS: 'last30Days',
  LAST_90_DAYS: 'last90Days',
  LAST_SIX_MONTHS: 'lastSixMonths',
  LAST_YEAR: 'lastYear',
  CUSTOM: 'customDate',
};

export const RANGE_DATE_PRESET_DEFS = [
  {
    id: RANGE_DATE_PRESET.LAST_7_DAYS,
    labelKey: 'Last7Days',
    value: 7,
  },
  {
    id: RANGE_DATE_PRESET.LAST_30_DAYS,
    labelKey: 'Last30Days',
    value: 30,
  },
  {
    id: RANGE_DATE_PRESET.LAST_90_DAYS,
    labelKey: 'Last90Days',
    value: 90,
  },
  {
    id: RANGE_DATE_PRESET.LAST_SIX_MONTHS,
    labelKey: 'LastSixMonths',
    value: 180,
  },
  {
    id: RANGE_DATE_PRESET.LAST_YEAR,
    labelKey: 'LastYear',
    value: 365,
  },
];

export function buildRangeDateOptions(translate) {
  return RANGE_DATE_PRESET_DEFS.map((preset) => ({
    id: preset.id,
    text: translate(preset.labelKey),
    filter_type: RANGE_DATE,
    type: 'date',
    value: preset.value,
  }));
}

export function getDefaultDateRangePreset() {
  return RANGE_DATE_PRESET_DEFS.find(
    (item) => item.id === RANGE_DATE_PRESET.LAST_30_DAYS
  );
}

export function buildDefaultDateRange(translate) {
  const preset = getDefaultDateRangePreset();
  return {
    id: preset.id,
    text: translate(preset.labelKey),
    filter_type: RANGE_DATE,
    type: 'date',
    value: preset.value,
  };
}

/** Shared by Dashboard buildQuery and assignment-report query. */
export function getRangeDateBounds({ id, value }) {
  if (id === RANGE_DATE_PRESET.CUSTOM) {
    return {
      date_from: value?.from,
      date_to: value?.to,
    };
  }

  const to = new Date();
  const from = subDays(to, value);

  return {
    date_from: format(from, 'yyyy-MM-dd'),
    date_to: format(to, 'yyyy-MM-dd'),
  };
}
